import request from 'umi-request';
import { environment } from './../../environment/environment';
import type { ApiResponse } from '../model/apiResponse';
import type { ProfileRequest } from '../model/profileResponse';

//List products
export async function GetProfile(token: string): Promise<ApiResponse> {
  return await request('/users/currentUser', {
    method: 'GET',
    prefix: environment.baseUrl,
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (response: ApiResponse) {
      return response
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}

export async function UpdateProfile(token: string, profileResponse: ProfileRequest): Promise<ApiResponse> {
  return await request('/users/updateAppUser', {
    method: 'PUT',
    prefix: environment.baseUrl,
    body: JSON.stringify(profileResponse),
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (response: ApiResponse) {
      return response
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}

